(function () {
	"use strict";

	// Side-nav labels (.dot-nav: "Our Solutions", "Behind InnoTECHT", …): the
	// builder places each one with a fixed offset, so it drifts away from the
	// section's heading as card/heading sizes change with viewport width. Line
	// the top of each label's capitals up with the top of the capitals of the
	// heading it belongs to:
	//   • a section with N labels and N card titles pairs them in DOM order
	//     (home "Our Solutions" / "Our Methods");
	//   • otherwise the label follows the section's first heading.
	// Measured from layout (offsetTop + font metrics), so scroll-reveal and pin
	// transforms can't skew it. Skipped where the label would collide with the
	// heading (label in its own row above, narrow viewports) and on the contact
	// slide of internal pages, whose heading is aligned to the label in
	// mask-zoom-effect.js instead.
	var DESKTOP = window.matchMedia("(min-width: 981px)");
	var inkCtx = document.createElement("canvas").getContext("2d");

	function offsetWithin(el, root) {
		var top = 0;
		while (el && el !== root) {
			top += el.offsetTop;
			el = el.offsetParent;
		}
		return el === root ? top : null;
	}

	// Distance from the element's border-box top to the top of a capital letter
	// on its first line: padding/border + half-leading + (font ascent − cap height).
	function capTopOffset(el) {
		var cs = getComputedStyle(el);
		inkCtx.font = cs.fontStyle + " " + cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
		var m = inkCtx.measureText("H");
		var fontAscent = m.fontBoundingBoxAscent;
		var fontHeight = fontAscent + m.fontBoundingBoxDescent;
		var lineHeight = parseFloat(cs.lineHeight);
		if (isNaN(lineHeight)) lineHeight = fontHeight; // line-height: normal
		var halfLeading = (lineHeight - fontHeight) / 2;
		return (
			(parseFloat(cs.borderTopWidth) || 0) +
			(parseFloat(cs.paddingTop) || 0) +
			halfLeading +
			fontAscent -
			m.actualBoundingBoxAscent
		);
	}

	function capTop(el, section) {
		var top = offsetWithin(el, section);
		return top === null ? null : top + capTopOffset(el);
	}

	// The builder wraps label text in <p>s and leaves an empty one first, which
	// pushes the visible text down — measure the first <p> that has text.
	function textEl(label) {
		var ps = label.querySelectorAll("p");
		for (var i = 0; i < ps.length; i++) {
			if (ps[i].textContent.trim()) return ps[i];
		}
		return label;
	}

	function textRect(el) {
		var r = document.createRange();
		r.selectNodeContents(el);
		return r.getBoundingClientRect();
	}

	function align(p) {
		var dot = p.dot;
		// Labels are hidden below the tablet breakpoint — leave mobile untouched.
		if (!DESKTOP.matches) {
			dot.style.transform = "";
			return;
		}

		var title = p.title || firstHeading(p.section, dot);
		var label = textEl(dot.querySelector(".label") || dot);
		if (!title || !visible(label)) {
			dot.style.transform = "";
			return;
		}

		// Label stacked above / overlapping the heading's columns: moving it down
		// would run it into the heading text, so leave the builder placement.
		// (Pinned sections slide horizontally, so their rects aren't stable.)
		if (!p.pinned && textRect(title).left - textRect(label).right < MIN_GAP) {
			dot.style.transform = "";
			return;
		}

		var labelTop = capTop(label, p.section);
		var titleTop = capTop(title, p.section);
		if (labelTop === null || titleTop === null) {
			dot.style.transform = "";
			return;
		}

		// offsetTop ignores transforms, so the measurement is already the
		// un-shifted layout position; this replaces the builder's fixed offset.
		var shift = titleTop - labelTop;
		dot.style.transform = "translateY(" + Math.round(shift * 10) / 10 + "px)";
	}

	var HEADING = "h1, h2, h3, h4, .et_pb_module_heading, .item-title";
	var MIN_GAP = 16; // px kept between the label text and the heading text

	function visible(el) {
		return el.getClientRects().length > 0;
	}

	function firstHeading(section, dot) {
		var all = section.querySelectorAll(HEADING);
		for (var i = 0; i < all.length; i++) {
			if (!dot.contains(all[i]) && all[i].textContent.trim() && visible(all[i])) {
				return all[i];
			}
		}
		return null;
	}

	function pairs() {
		var out = [];
		var isHome = document.body.classList.contains("home");
		document.querySelectorAll(".et_pb_section").forEach(function (section) {
			// Internal pages: the contact slide is handled by mask-zoom-effect.js.
			if (!isHome && section.id === "section8") return;
			var dots = section.querySelectorAll(".dot-nav");
			if (!dots.length) return;
			var titles = section.querySelectorAll(".item-title");
			var paired = dots.length > 1 && dots.length === titles.length;
			dots.forEach(function (dot, i) {
				out.push({
					dot: dot,
					section: section,
					pinned: !!section.querySelector(".pin-content-wrapper, .pin-wrap"),
					title: paired ? titles[i] : null,
				});
			});
		});
		return out;
	}

	function init() {
		var list = pairs();
		if (!list.length) return;

		var timer;
		function run() {
			list.forEach(align);
		}
		function schedule() {
			clearTimeout(timer);
			timer = setTimeout(run, 100);
		}

		run();
		window.addEventListener("load", run);
		window.addEventListener("resize", schedule);
		if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);

		if (window.ResizeObserver) {
			var ro = new ResizeObserver(schedule);
			var seen = [];
			list.forEach(function (p) {
				if (seen.indexOf(p.section) === -1) {
					seen.push(p.section);
					ro.observe(p.section);
				}
			});
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
